export enum VatAccountsSortProperty {
  Priority = 'priority',
}
